import OrderWrapper from "../../components/Order/OrderWrapper";
import Cart from "../../components/Order/Cart";
import Header from "../../components/Order/Header";
import ElementList from "../../components/Order/ElementList";
import { MarketProvider } from "../../contexts/MarketContext";

export default function MarketplacePage() {
    
    return (
        <OrderWrapper>
            <MarketProvider>
                <Header />
                <ElementList />
                <Cart />
            </MarketProvider>
        </OrderWrapper>
    );
}
